import { Module } from 'vuex';
import { IProductType } from '@/shared/model/product-type.model';
import { IShop } from '@/shared/model/shop.model';

type UIState = {
  order: {
    filters: {
      status: string;
    };
  };
  product: {
    filters: {
      productType: IProductType;
      shop: IShop;
    };
  };
  productType: {
    filters: {
      shop: IShop;
    };
  };
};

const initialState: UIState = {
  order: {
    filters: {
      status: 'ALL',
    },
  },
  product: {
    filters: {
      productType: null,
      shop: null,
    },
  },
  productType: {
    filters: {
      shop: null,
    },
  },
};

export const uiStore: Module<UIState, any> = {
  state: { ...initialState },
  getters: {
    orderState: state => state.order,
    productState: state => state.product,
    productTypeState: state => state.productType,
  },
  mutations: {
    setOrderFilters: (state, orderFilters) => {
      const previousOrderFilters = { ...state.order.filters };
      state.order.filters = {
        ...previousOrderFilters,
        ...orderFilters,
      };
    },
    setProductFilters: (state, productFilters) => {
      const previousProductFilters = { ...state.product.filters };
      state.product.filters = {
        ...previousProductFilters,
        ...productFilters,
      };
    },
    setProductTypeFilters: (state, productTypeFilters) => {
      const previousProductTypeFilters = { ...state.productType.filters };
      state.productType.filters = {
        ...previousProductTypeFilters,
        ...productTypeFilters,
      };
    },
  },
};
